import util from "@/components/shared/util";
import _ from "lodash";

const doingWork: Record<string, boolean | string> = {};

const queues: Record<string, Array<any>> = {};
let isScrolling = false;
export function currentlyScrolling() {
  return isScrolling;
}
const subscribers: Array<Function> = [];
function notifySubscribers() {
  subscribers.forEach(cb => {
    cb();
  });
  // Only call them back one time, need to register again if you want another callback
  subscribers.length = 0;
}

export function registerForScrollingStop(cb: Function) {
  subscribers.push(cb);
  return cb;
}

async function processQueue(key: string) {
  if (isScrolling) {
    return;
  }

  if (!doingWork[key]) {
    if (queues[key].length) {
      const { cb, id } = queues[key][0];
      doingWork[key] = id || true;
      cb(() => done(key));
    }
  }
}
const isAsync = true;
async function done(key: string) {
  if (!isAsync) {
    return;
  }
  const { resolve } = queues[key].shift();
  await util.animationFrame();
  doingWork[key] = false;
  resolve(true);
  processQueue(key);
}

let watchingScroll: boolean;

export function AsyncQueue(cb: Function, key = "__shared", id: number = -1) {
  if (!isAsync) {
    cb(() => done(key));
    return { promise: Promise.resolve(true), dequeue: _.noop };
  }
  if (!watchingScroll) {
    watchingScroll = watchScroll();
  }

  if (!queues[key]) {
    queues[key] = [];
  }
  let resolve: any;
  const promise = new Promise(r => {
    resolve = r;
  });

  queues[key].push({ cb, resolve, id });

  window.requestAnimationFrame(() => processQueue(key));

  const dequeue = createCancelQueue(key, resolve);

  return { promise, dequeue };
}

function createCancelQueue(key: string, resolve: Function) {
  return () => {
    const index = queues[key].findIndex(item => {
      const found = item.resolve === resolve;
      if (found) {
        item.resolve(false);
      }
      return found;
    });
    doingWork[key] = false;
    queues[key].splice(index, 1);
  };
}

const debouncedScroll = _.debounce(() => {
  isScrolling = false;
  notifySubscribers();
  Object.keys(queues).forEach(key => {
    processQueue(key);
  });
}, 500);

// Could be passed if it changes...
function getElement() {
  const element = document.getElementById("censusContent") as HTMLElement;
  if (!element) {
    return;
  }
  return element.children[0];
}

function watchScroll() {
  const contentWrapElement = getElement();

  if (!contentWrapElement) {
    return false;
  }
  contentWrapElement.addEventListener("scroll", () => {
    isScrolling = true;
    debouncedScroll();
  });
  return true;
}
